import type * as React from 'react';
import type { ButtonProps } from '@components/molecules';

export enum CopyButtonStateEnum {
	IDLE = 'idle',
	COPY_SUCCESS = 'copy_success',
	COPY_FAIL = 'copy_fail',
}

export type CopyButtonProps = ButtonProps & {
	text: string;
	icon?: React.ReactNode;
	onCopied?: () => void;
	onCopyFailed?: (reason: Error) => void;
	delay?: number;
	successTitle?: string;
	failedTitle?: string;
};
